module.exports = __webpack_public_path__ + "img/xjb-adv4.jpg";